export default {"src":"/_next/static/media/swimming-pool.6ca33cb7.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};